import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-card-campanha-dash',
  imports: [
    CommonModule,
    TagModule,
    Menu,
    ButtonModule,
    MoneyPipe
  ],
  templateUrl: './card-campanha-dash.component.html',
  styleUrl: './card-campanha-dash.component.scss'
})
export class CardCampanhaDashComponent implements OnInit {
  @Input() dados!: any[];
  @Input() codigo!: string;
  @Input() titulo!: string;
  @Input() Sector!: string;
  @Input() Objectivo!: string;
  @Input() Arrecadado!: string;
  @Input() estado!: string;
  @Input() DataCriacao!: string;
  openedMenu: Menu | null = null;
  @Input() actions: ((rowData: any) => MenuItem[]) | MenuItem[] = [];
  @Output() rowClick = new EventEmitter<any>();
  @Input() campanha!: any;
  @Input() activeMenu!: Menu | null;
  @Output() menuOpened = new EventEmitter<Menu>();
  @Output() menuClosed = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  getSeverity(state: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | null | undefined {
    switch (state) {
      case 'Rascunho':
        return 'secondary';
      case 'Em curso':
        return 'info';
      case 'Pendente':
        return 'secondary';
      case 'Encerrado':
        return 'success';
      case 'Suspensa':
        return 'warn';
      case 'Recusado':
        return 'danger';
      case 'Publicado':
        return 'success';
      default:
        return 'info';
    }
  }

  getMenuActions(rowData: any): MenuItem[] {
    if (typeof this.actions === 'function') {
      return this.actions(rowData);
    }

    return this.actions.map((action) => ({
      ...action,
      data: rowData,
    }));
  }

  updateMenuActions() {
    if (!this.dados) return;

    this.dados = this.dados.map(rowData => ({
      ...rowData,
      menuActions: this.getMenuActions(rowData),
    }));
  }

  openMenu(event: MouseEvent, menu: Menu) {
    event.preventDefault();
    event.stopPropagation();

    this.menuOpened.emit(menu);
    menu.show(event);
  }

  onRowClick(rowData: any) {
    this.rowClick.emit(rowData);
  }

}